import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { firstValueFrom } from 'rxjs';
import { MSSPService } from './mssp.service';
import { StorageService } from './storage.service';
import { TranslateService } from '@ngx-translate/core';
import { DecodeToken } from '../model/decode-token-item';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class GuardService {
  token: string = ""
  JWT = new JwtHelperService();
  vectorLanguajes: any;

  constructor(
    private msspService: MSSPService, 
    private storageService: StorageService,
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private commonService: CommonService) { }

   async validateCredentials(token: string): Promise<boolean> {  
    
    return new Promise<boolean>(async (resolve) => {
      this.storageService.saveData('encodedToken', token);
      const deco = this.JWT.decodeToken(token);
      const decodeToken = new DecodeToken(
        token,
        deco.sessionId,
        deco.poliza, 
        deco.dealerCode,
        deco.certificado,  
        deco.RFC
      );
      this.msspService.DecodeToken(decodeToken).subscribe(response => {
        //|| (deco && deco.poliza != sessionStorage.getItem('policy'))
        if ((deco && deco.sessionId && deco.poliza && deco.dealerCode && deco.certificado)) {
            firstValueFrom(this.msspService.getClientInfo(deco.dealerCode)).then(async val => {
              if (val) {
              
                await this.loadTheme(val.data.NombreCliente);
                this.loadLanguaje(val.data.NombreCliente, this.translate);
                this.storageService.saveData("sessionId", deco.sessionId);
                this.storageService.saveData("policy", deco.poliza);
                this.storageService.saveData("apiKey", val.data.ApiKey);
                this.storageService.saveData("tokenMSSP", val.data.Tokens);
                this.storageService.saveData("client", val.data.NombreCliente);
                this.storageService.saveData("idClient", val.data.IdCliente);
                this.storageService.saveData("auth", deco.RFC);
                this.storageService.saveData("risk", val.data.RiskTypeCode);
                this.storageService.saveData("certificado", deco.certificado);
                this.storageService.saveData("isMultiple", val.data.Multiple);
                this.commonService.isMultipleCertificate = val.data.Multiple;
                this.storageService.saveData("dealerCode", decodeToken.dealerCode);
                this.commonService.dealerCode = decodeToken.dealerCode;
                // return true
                resolve(true);
              }
            }).catch(reason => {
              resolve(false);
            })
        } else if (sessionStorage.getItem('sessionId')) {
          var clientName = sessionStorage.getItem('client')
          if (this.verifyLetterAndNumber(clientName || '')) {
            this.loadTheme(clientName || 'liverpool').then(resp => {
              resolve(true);
            }).catch(err => {
              resolve(true);
            })
            // return true
            
          }
        } else  {
          resolve(false);
        } 
        // // return false
        // resolve(false);
      })
    })
    
  }

  async loadTheme(themeName: string): Promise<void> {

    // themeName = 'liverpool';
    const fnApplyTheme = async ():Promise<void> => {
      return new Promise<void>((resolve, reject) => {
        const head = this.document.getElementsByTagName('head')[0];
        const style = this.document.createElement('link');
        style.rel = "stylesheet";
        style.href = `${themeName}.css`;
        style.as = "style"
        head.appendChild(style);
        const lowerThemeName = themeName.toLowerCase()
        const styleFavicon = this.document.createElement('link');
        styleFavicon.rel = "icon";
        styleFavicon.type = "image/x-icon";
        styleFavicon.href = "/assets/themes/" + `${lowerThemeName}` + "/img/favicon.ico";
        head.appendChild(styleFavicon);
        resolve();
      })
    } 

    return new Promise<void>(async(resolve, reject) => {
      try {
        const themeFileResponse = await fetch(`${themeName}.css`, { method: 'GET' });
        if (!themeFileResponse.ok) {
          throw new Error(`No se encontro el archivo ${themeName}.css`)
        }
        await fnApplyTheme();
        resolve();
      } catch (error) {
        console.log(error);
        resolve();
      }
    })
    
  }

  verifyLetterAndNumber(str: string): boolean {
    return /^[A-Za-z0-9]*$/.test(str);
  }


  loadLanguaje(ClientName: string, translate: any) {
    //this.msspService.get(ClientName).subscribe((req) => {
    //if (req) {

    //    req.forEach((myObject: { languaje: any; }) => {
    //      if (!myObject) {
    //        this.vectorLanguajes.push(myObject)
    //      }
    //    });
    //  }
    //});
    translate.addLangs(['es-ES']);

    //translate.addLangs(this.vectorLanguajes);
    translate.setDefaultLang('es-ES');

    const browserLang = translate.getBrowserLang();
    const result = translate.store.langs.filter((lenguaje: string) => lenguaje.includes(browserLang));

    translate.use(result[0] ? result[0] : 'es-ES');
    console.log('var', translate.currentLang);
  }

}
